import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    transition-duration: 0.4s;

  }


  body {
    background: #fff;
    color: #212029;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 900;
  }

  button {
    cursor: pointer;
  }

  :root {
    --primary: red;
  }

`;
